import request from '@/CommonDP/utils/request';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';
// 图纸问题模块接口
export default {
  getDrawingQuestionSearchList(prjId) {
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/getFilterConditions?prjId=${prjId}`); } else {
      return request.get(`${globalParams.get('queryFilterDicReq')}?prjId=${prjId}`);
    }
  },
  // 图纸
  getDrawingQuestionPageList(data) {
    // return request.post('/drawing/question-page-list?pageNo='+pageNo+'&pageSize='+pageSize,data)
    if (globalParams.get('isHky')) {
      return request.post(`${globalParams.get('queryNotationlistReq')}`, data);
    }
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post(`/drawing-annotation/list`, data);
  },
  getH5queestList(params) {
    return request.post(`/drawing-annotation/list`, params);
  },
  getH5DrawingQuestionSearchList(prjId) {
    return request.get(`/drawing-annotation/getFilterConditions?prjId=${prjId}`);
  },
  getDrawingQuestionDetails(questionId) {
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/getById?id=${questionId}`); } else {
      return request.get(`${globalParams.get('queryQuestionDetailsReq')}?id=${questionId}`);
    }
  },
  getDrawingQuestionRecord(id) {
    return request
      .get(`/drawing-annotation/getStatusUpdateRecordList?id=${id}`)
      .then((res) => res);
  },
  getCommentList(relaId, prjId) {
    return request
      .get(`/comment/list?relaId=${relaId}&prjId=${prjId}`)
      .then((res) => res);
  },
  createComment(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/comment/add");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post('/comment/add', data);
  },
  DrawingQuestionDelete(ids) {
    return request
      .post(`/drawing-annotation/delete`, ids)
      .then((res) => res);
  },
  queryDict(prjId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(`/dic/content/list?dicCode=QueStatus&prjId=${prjId}`)
      .then((res) => res);
  },
  // drawing-annotation/dicList接口传fileId或者folderId都可以
  queryDict2(prjId, fileId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/dicList?prjId=${prjId}&fileId=${fileId}`); } else {
      return request.get(`${globalParams.get('queryNotationDicReq')}?prjId=${prjId}&fileId=${fileId}`);
    }
  },
  queryDict1(prjId, folderId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(
        `/drawing-annotation/dicList?prjId=${prjId}&folderId=${folderId}`
      )
      .then((res) => res);
  },
  DrawingQuestionStatusBatchEdit(data) {
    return request.post('/drawing-annotation/batchUpdateStatus', data);
  },
  DrawingQuestionquesti(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/updateModifier");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post('/drawing-annotation/updateModifier', data);
  },
  getUserInfoListByPrjId(prjId) {
    return request
      .get(`/project/getProjectUsers?projectId=${prjId}`)
      .then((res) => res);
  },
  DrawingQuestionEdit(data) {
    return request.post('/lc/drawing-annotation/update', data);
  },
  recallComment(commentId) {
    return request
      .get(`/comment/delete/${commentId}`)
      .then((res) => res);
  },
  drawingDrawingQuesExport(params1) {
    return request({
      responseType: 'blob',
      url: '/drawing-annotation/export',
      method: 'post',
      data: params1
    });
  },
  drawingannotationupdateStatus(data) {
    return request.post('/drawing-annotation/updateStatus', data);
  },
  batchUpdatecount(data) {
    return request.post('/drawing-annotation/batchUpdate/count', data);
  }
};
